import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import { AccountProvider } from './context/AccountContext';
import { ToastProvider } from './context/ToastContext';
import { ConfigProvider } from 'antd';
import storage from './utils/storage';
import App from './App';

import './styles.css';
import './index.css';

// Migrate bare localStorage keys to prefixed keys (one-time)
storage.migrate();

if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/sw.js')
    .then(function (registration) {

    })
    .catch(function (error) {
      console.log('Service Worker registration failed:', error);
    });
}
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  //  <React.StrictMode>
  <BrowserRouter>
    <ToastProvider>
      <AccountProvider>
        <ConfigProvider
          getPopupContainer={() => document.getElementById("overlay-root")!}
        >
          <App />
        </ConfigProvider>
      </AccountProvider>
    </ToastProvider>
  </BrowserRouter>
  //  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

;
